import { createContext, useContext } from 'react';
import type { RuntimeConfig } from './config';
import type { MiniAppApi } from './api';

export const ConfigContext = createContext<RuntimeConfig | null>(null);
export const ApiContext = createContext<MiniAppApi | null>(null);

export function useRuntimeConfig(): RuntimeConfig {
  const ctx = useContext(ConfigContext);
  if (!ctx) {
    throw new Error('useRuntimeConfig must be used within ConfigProvider');
  }
  return ctx;
}

export function useMiniAppApi(): MiniAppApi {
  const ctx = useContext(ApiContext);
  if (!ctx) {
    throw new Error('useMiniAppApi must be used within ApiProvider');
  }
  return ctx;
}
